import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split2chars',
  standalone: false
})
export class Split2charsPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    const numbers = value.match(/\d{0,2}/g).join(' ').trim();
    // If the commission is greater than 14, don't show it
    if (numbers.length === 2 && Number(numbers) > 14) {
      return '';
    }
    return numbers;
  }

}
